module.exports = __webpack_public_path__ + "static/media/delhi-covid-infographics1.b51abb67.svg";